// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  amplifyEnv: 'dev',
  serviceEnv: 'dev',
  domain: 'https://dcr-portal-dev.dna.nfl.net',
  region: 'us-east-1',
  auth: {
    hostname: 'dcr-portal-dev-login.auth.us-east-1.amazoncognito.com',
    redirect_uri: ['https://dcr-portal-dev.dna.nfl.net/login'],
    response_type: 'code',
    client_id: '73vqc78gj3c9ci476aaqfi8k3u',
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    user_pool_id: 'us-east-1_lBhl1jIPl',
    identity_pool_id: 'us-east-1:aa944390-2646-4c7b-a526-43ffd0244095',
    domain: 'dcr-portal-dev.dna.nfl.net',
  },
  api: {
    aws_appsync_graphqlEndpoint: 'https://dcr-portal-dev.dna.nfl.net/graphql',
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: 'userPool',
  },
  dcr_hub_link: 'https://dcr-hub-dev.dna.nfl.net/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
